export enum LocalStorageKey {
  hasVisited = 'HAS_VISITED',
  cookieBannerDisplayed = 'COOKIE_BANNER_DISPLAYED',

  // Persists authenticator token for client-side API calls across sessions
  authenticatorAccessToken = 'PMC_AUTHENTICATOR_ACCESS_TOKEN',
}
